module.exports = __webpack_public_path__ + "static/media/bg13.2fa7d9c0.jpg";